// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Jd1b","bigColWidth":"Table_bigColWidth__2T31m","biggerColWidth":"Table_biggerColWidth__2WTGS","row":"Table_row__36x9E","col":"Table_col__pVDGP"};